import {combineReducers} from 'redux';
import uiReducer from './uiReducer';
import disambiguationReducer from './disambiguationReducer';
import settingReducer from './settingReducer';
import userReducer from './userReducer';
import analyticsReducer from './analyticsReducer';
import launchDarklyReducer from './launchDarklyReducer';

export default combineReducers({
  uiOptions: uiReducer,
  workflowPrompts: disambiguationReducer,
  appSettings: settingReducer,
  userData: userReducer,
  analytics: analyticsReducer,
  launchDarkly: launchDarklyReducer,
});
